
import router from '@/router'
import axios from 'axios' 
import { getDomainToken, getToken } from '@/api/cookies'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

service.interceptors.request.use(
  (config) => {
    var DomainAuthorization = process.env.VUE_APP_BASE_IfAl == 'true'
      ? getDomainToken()
      : 'entrants:1b22c90fdd7a4b4494dc0dbbaa1ce1f3'
    var token = getToken()
    
    if (DomainAuthorization) {
      config.headers["DomainAuthorization"] = DomainAuthorization;
      config.headers['terminal'] = 'pc'
    }
    
    config.headers['type'] = '1'
    if (token) {
      config.headers['authorization'] = 'Bearer ' + token
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code == 500) {
      if (res.msg == 'token 已经过期无效' || res.msg == '登录失效，请重新登录') {
     
         const DomainAuthorization = localStorage.getItem('DomainAuthorization');
              const domain = localStorage.getItem('domain');
              localStorage.clear();
              if (DomainAuthorization) localStorage.setItem('DomainAuthorization', DomainAuthorization);
              if (domain) localStorage.setItem('domain', domain);
     
        router.replace(`/`)
      } else {
        return response.data
      }
    }else if(res.code == 201 || res.code == 204) {
        const DomainAuthorization = localStorage.getItem('DomainAuthorization');
              const domain = localStorage.getItem('domain');
              localStorage.clear();
              if (DomainAuthorization) localStorage.setItem('DomainAuthorization', DomainAuthorization);
              if (domain) localStorage.setItem('domain', domain);
     
        router.replace(`/`)
    } else {
      return response.data
    }
  },
  (error) => {
    console.log('服务器调用错误')
    return Promise.reject(error)
  }
)

export default service
